var initialState = {open:false}

export default function reducer(state=initialState, action){

    switch (action.type){
        case "OPEN_DRAWER":{
            return {
                open:true
            }
        }
        case "CLOSE_DRAWER":{
            return {
                open:false
            }
        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/shared/drawer.js